import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  EntityService,
  CollectionManagerService
} from '@zerops/zef/entities';
import { AppState, ApiEntityKeys } from '@zerops/zerops/app';
import { ZefWebsocketService } from '@zerops/zef/websocket';
import { ResourceConsumption } from '@zerops/models/resource-consumption';

@Injectable({ providedIn: 'root' })
export class ResourceConsumptionEntity extends EntityService<ResourceConsumption> {


  constructor(
    public store: Store<AppState>,
    public collectionManager: CollectionManagerService,
    public websocketResourceConsumption: ZefWebsocketService
  ) {
    super(ApiEntityKeys.ResourceConsumption, store, collectionManager, websocketResourceConsumption);
  }
}
